import { render, staticRenderFns } from "./newsMobileDetails.vue?vue&type=template&id=64733d1e&scoped=true&"
import script from "./newsMobileDetails.vue?vue&type=script&lang=js&"
export * from "./newsMobileDetails.vue?vue&type=script&lang=js&"
import style0 from "./newsMobileDetails.vue?vue&type=style&index=0&id=64733d1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64733d1e",
  null
  
)

export default component.exports